import { z } from 'zod';

import { FlowUiMode } from '../../../scenes/Agents/Flows/ReactFlow/context/uiMode';
import { EventAction } from '../types';

const FlowSchema = z.strictObject({
  flowId: z.uuid(),
  flowName: z.string().optional(),
});

export const ContentFreeFlowAiPropertySchemasByAction = {
  [EventAction.OpenButtonClick]: FlowSchema.extend({ location: z.enum(FlowUiMode) }),
  [EventAction.SubmitButtonClick]: FlowSchema,
  [EventAction.ResponseStreamBegin]: FlowSchema,
  [EventAction.NewConversationButtonClick]: FlowSchema,
  [EventAction.ApplyAllButtonClick]: FlowSchema,
  [EventAction.AgentCreateButtonClick]: z.strictObject({}),
} satisfies Partial<Record<EventAction, z.ZodObject>>;

export type ContentFreeFlowAiEvent = {
  [Action in keyof typeof ContentFreeFlowAiPropertySchemasByAction]: {
    action: Action;
    properties: z.infer<(typeof ContentFreeFlowAiPropertySchemasByAction)[Action]>;
  };
}[keyof typeof ContentFreeFlowAiPropertySchemasByAction];
